import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function EggIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4785 9.2758L13.4787 9.27568L17.0906 11.5742C16.8931 5.97211 13.946 1.66699 10.2178 1.66699C6.48979 1.66699 3.54267 5.97196 3.3451 11.5739L3.34467 11.5741C3.33769 11.7727 3.33337 11.9725 3.33337 12.1742C3.33337 16.0299 6.83343 18.3336 10.2174 18.3336C13.6014 18.3336 17.1015 16.0299 17.1015 12.1742C17.1015 11.9725 17.0972 11.7727 17.0902 11.5741L13.4785 9.2758ZM6.95678 9.2758L10.2174 11.4496L10.2176 11.4494L6.95697 9.27568L6.95678 9.2758Z"
          fill="url(#paint0_linear_egg)"
        />
        <Path
          d="M17.0688 11.1309L13.6729 8.96989C13.5519 8.89276 13.3969 8.89418 13.2773 8.97414L10.2175 11.0139L7.15757 8.97414C7.03797 8.89418 6.883 8.89276 6.76199 8.96989L3.36609 11.1309C3.34822 11.4199 3.33891 11.7131 3.33606 12.0091L6.95199 9.70798L10.0165 11.751C10.1382 11.8324 10.2967 11.8324 10.4184 11.751L13.4829 9.70798L17.0989 12.0091C17.096 11.7131 17.0867 11.4199 17.0688 11.1309Z"
          fill="#F6EC91"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_egg"
            x1="3.33337"
            y1="5.28144"
            x2="12.244"
            y2="20.3221"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
